import { Analysis, IAsset } from '@core';
import { VideoPayload } from '@data';

export type FullSwing = {
    uuid: string;
    videos: VideoPayload[];
    analysis: Analysis;
    images: IAsset[];
};

type PartialSwing = {
    uuid: string;
    videos: VideoPayload[] | null;
    analysis: Analysis | null;
    images: IAsset[] | null;
};

export class PartialSwingCache {
    private entries: Record<string, PartialSwing> = {};

    mergeVideos(uuid: string, videos: VideoPayload[]): FullSwing | null {
        const entry = this.getOrCreate(uuid);
        entry.videos = videos;
        return this.finalize(uuid);
    }

    mergeAnalysis(uuid: string, analysis: Analysis): FullSwing | null {
        const entry = this.getOrCreate(uuid);
        entry.analysis = analysis;
        return this.finalize(uuid);
    }

    mergeImages(uuid: string, images: IAsset[]): FullSwing | null {
        const entry = this.getOrCreate(uuid);
        entry.images = images;
        return this.finalize(uuid);
    }

    private getOrCreate(uuid: string): PartialSwing {
        if (!this.entries[uuid]) {
            this.entries[uuid] = {
                uuid,
                videos: null,
                analysis: null,
                images: null,
            };
        }
        return this.entries[uuid];
    }

    private finalize(uuid: string): FullSwing | null {
        const entry = this.entries[uuid];
        if (!entry.videos || !entry.analysis || !entry.images) {
            return null;
        }

        const full: FullSwing = {
            uuid: entry.uuid,
            videos: entry.videos,
            analysis: entry.analysis,
            images: entry.images,
        };
        delete this.entries[uuid];
        return full;
    }
}
